/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PlatformFee/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PlatformFee({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods/Method/Details/Card/PlatformFee",
  amount
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let reusableMethodProviderLocationAccountFeeModeValueData = fromData.useDataValue({ viewPath,
context: 'reusable_method',
path: 'provider_location_account.fee_mode',
})
let reusableMethodFeeEligibleValueData = fromData.useDataValue({ viewPath,
context: 'reusable_method',
path: 'fee_eligible',
})
let aggregateData = fromHelpers.getView(reusableMethodProviderLocationAccountFeeModeValueData, reusableMethodFeeEligibleValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 amount={amount}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}